import type {AccountFeatures} from '@/types/features.types';

export const accountFeatures: AccountFeatures = {};
